import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import FirmyTable from "./components/FirmyTable";
import {TopButtonAdd} from "../../../componentsTopsa/buttons/TopButtons";
import FirmyForm from "./components/FirmyForm";
import FirmyService from "./FirmyService";
import ReactNotify from 'react-notify';
import ScrollUtilities from "../../../utilities/ScrollUtilities";


export default class FirmyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firmy: [],
            edytowanaFirma: null,
            pokazFormularz: false,
        };
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.pobierzFirmy()
    }

    pobierzFirmy() {
        FirmyService.getFirmy().then(function (response) {
            this.setState({
                firmy: response.data
            })
        }.bind(this))
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({edytowanaFirma: obj, pokazFormularz: true})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy na pewno chcesz usunąć firmę ' + obj.nazwa + '?')) {
            FirmyService.deleteFirma(obj.idFi).then(function (res) {
                if (res.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto firmę', "", 3000)
                    this.pobierzFirmy()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania firmy', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            FirmyService.editFirma(this.state.edytowanaFirma.idFi, obj).then(function (response) {

                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano firmę', "", 3000)
                    this.pobierzFirmy()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji firmy', "", 3000)
                }

                this.setState({
                    edytowanaFirma: null, pokazFormularz: false
                })
            }.bind(this))


        }
        else {
            FirmyService.addFirma(obj).then(function (response) {

                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano firmę', "", 3000)
                    this.pobierzFirmy()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania firmy', "", 3000)
                }

                this.setState({
                    edytowanaFirma: null, pokazFormularz: false
                })
            }.bind(this))

        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'KlienciContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/firmy', text: 'Firmy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            {
                                Boolean(this.state.pokazFormularz) ?
                                    <FirmyForm
                                        edytowanaFirma={this.state.edytowanaFirma}
                                        czyMoznaEdytowacNip={!(Boolean(this.state.edytowanaFirma))}
                                        handleClickAnuluj={() => {
                                            this.setState({pokazFormularz: false, edytowanaFirma: null})
                                        }}
                                        handleClickZapisz={this.onClickZapisz}
                                    />
                                    :
                                    <div className={'pull-right'}>
                                        <TopButtonAdd onClick={() => {
                                            this.setState({pokazFormularz: true}); ScrollUtilities.scrollToTop()
                                        }}/>
                                    </div>
                            }
                        </Col>
                        <Col sm={12}>
                            <FirmyTable data={this.state.firmy}
                                        handleClickEdytuj={this.onClickEdytuj}
                                        handleClickUsun={this.onClickUsun}

                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/firmy/FirmyContainer.js